(function(angular, module) {var TagIndexController, assign, getTagTypes, tagIndexComponent, tagLoader;

TagIndexController = function($state, $http, ApiUrl) {
  'ngInject';
  var loadTags, vm;
  vm = this;
  this.showForm = false;
  this.searchText = null;
  this.loading = true;
  this.programSpecific = this.program != null;
  this.editableTypes = [];
  loadTags = tagLoader($http, ApiUrl, this.program);
  this.setTagFor = function(tagFor) {
    var i, len, ref, type;
    vm.tagFor = tagFor;
    vm.refresh();
    vm.editableTypes = [];
    ref = tagFor.types;
    for (i = 0, len = ref.length; i < len; i++) {
      type = ref[i];
      if (type.editable) {
        vm.editableTypes.push(type);
      }
    }
  };
  this.refresh = function() {
    var params, ref;
    params = {
      q: vm.searchText,
      tag_for: vm.tagFor.name,
      program_id: (ref = vm.program) != null ? ref.id : void 0
    };
    return loadTags(params).then(function(data) {
      vm.tags = data.items;
      vm.counts = data.counts;
    });
  };
  this.tagCreated = function(tag) {
    $state.go('^.view', {
      tagId: tag.id
    });
    return tag;
  };
  getTagTypes($http, ApiUrl, this.program).then(function(tagTypes) {
    vm.tagTypes = tagTypes;
    vm.setTagFor(tagTypes[0]);
    return vm.refresh();
  });
};

tagLoader = function($http, ApiUrl, program) {
  return function(params) {
    var url;
    url = ApiUrl('tag');
    return $http.get(url, {
      params: params
    }).then(function(r) {
      return r.data;
    });
  };
};

getTagTypes = function($http, ApiUrl, program) {
  var params, url;
  url = ApiUrl('tag', 'types');
  params = {
    program_id: program != null ? program.id : void 0
  };
  return $http.get(url, {
    params: params
  }).then(function(r) {
    return r.data.items;
  });
};

assign = function(obj, name) {
  return function(value) {
    obj[name] = value;
    console.log(obj);
    return value;
  };
};

tagIndexComponent = {
  controller: TagIndexController,
  controllerAs: 'tagIndex',
  templateUrl: 'tags/index',
  bindings: {
    program: '='
  }
};

module.component('tagIndex', tagIndexComponent);
})(angular, angular.module("dybTags"));